/* eslint-disable css-modules/no-undef-class, css-modules/no-unused-class, no-nested-ternary */
import { ChangeEvent, FC, useState, FocusEvent, useEffect } from 'react';
import { TextField, Theme } from '@mui/material';
import { InputProps } from './inputTypes';
import { createStyles, makeStyles } from '../uiLibraryImports';
import styles from './input.module.scss';

const Input: FC<InputProps> = (props: InputProps) => {
    const {
        inputText,
        onChange,
        autofocus,
        onBlurFunction,
        multiline,
        numberOfLines,
        placeHolderText,
        maxLength,
        disabled,
        theme = 'dark'
    } = props;
    const [text, setText] = useState<string>(inputText);

    const handleOnChange = (e: ChangeEvent<HTMLInputElement>): void => {
        const { value } = e.target;
        setText(value);
        onChange(value);
    };

    useEffect(() => {
        setText(inputText);
    }, [inputText]);

    const useStyles = makeStyles((_: Theme) =>
        createStyles({
            cssOutlinedInput: {
                width: '100% !important',
                background: theme === 'dark' ? 'rgba(38, 35, 58, 0.5)' : 'transparent',
                color: theme === 'dark' ? 'white' : '#626262 !important',
                alignItems: multiline ? 'start !important' : 'center',
                '&$cssFocused $notchedOutline': {
                    borderColor:
                        theme === 'dark' ? 'rgba(71, 154, 235, 1) !important' : 'rgba(113, 101, 150, 0.50) !important'
                },
                '&:hover fieldset': {
                    borderColor:
                        theme === 'dark'
                            ? 'rgba(255, 255, 255, 0.7) !important'
                            : 'rgba(113, 101, 150, 0.50) !important'
                }
            },
            cssFocused: {},
            notchedOutline: {
                borderColor:
                    theme === 'dark' ? 'rgba(255, 255, 255, 0.25) !important' : 'rgba(113, 101, 150, 0.50) !important'
            },
            helperText: {
                textAlign: 'left',
                marginLeft: 0,
                marginTop: 0,
                color: 'rgba(241, 96, 93, 1) !important'
            }
        })
    );
    const classes = useStyles();

    return (
        <TextField
            id="input"
            multiline={multiline}
            className={styles.input}
            type="text"
            rows={numberOfLines}
            value={text}
            autoFocus={autofocus}
            onChange={handleOnChange}
            FormHelperTextProps={{
                className: classes.helperText
            }}
            disabled={disabled}
            placeholder={placeHolderText}
            onBlur={(_: FocusEvent<HTMLInputElement>): void => onBlurFunction?.(text)}
            variant="outlined"
            inputProps={{
                maxLength,
                'data-testid': 'input'
            }}
            InputProps={{
                classes: {
                    root: classes.cssOutlinedInput,
                    focused: classes.cssFocused,
                    notchedOutline: classes.notchedOutline
                }
            }}
        />
    );
};

export default Input;
